/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

// function findNodePath(jsonObj: any, key: string, value: any, pathValsKey = 'nodeId'): any[] {
//     function findPath(jsonObj: any, key: string, value: any, path: any = [], pathValsKey = 'nodeId', ) {
//         if(jsonObj === null || typeof jsonObj !== 'object') {
//             return [];
//         }
//         if(jsonObj[key] === value) {
//             return [...path, jsonObj[pathValsKey]];
//         }
//         if(Array.isArray(jsonObj.children)) {
//             // if children is an array, loop through each element
//             for(let child of jsonObj.children) {
//                 let result: any[] = findPath(child, key, value, [...path, jsonObj[pathValsKey]]);
//                 if(result.length) {
//                     return result;
//                 }
//             }
//         }
//         return [];
//     }
//     let path = findPath(jsonObj, key, value);
//     path.pop();
//     return path;
// }

function findNodePath(jsonObj, key, value, pathValsKey = 'nodeId') {
    function findPath(jsonObj, key, value, path = [], pathValsKey = 'nodeId') {
        if(jsonObj === null || typeof jsonObj !== 'object') {
            return [];
        }
        if(jsonObj[key] === value) {
            return [...path, jsonObj[pathValsKey]];
        }
        if(Array.isArray(jsonObj.children)) {
            // if children is an array, loop through each element
            for(let child of jsonObj.children) {
                let result = findPath(child, key, value, [...path, jsonObj[pathValsKey]],pathValsKey);
                if(result.length) {
                    return result;
                }
            }
        }
        return [];
    }
    let path = findPath(jsonObj, key, value,[],pathValsKey);
    path.pop();
    return path;
}

export {findNodePath}